webpackJsonp([105124497002074],{

/***/ 1761:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"DiagnosticEdge","kind":"OBJECT","type":"OBJECT","fields":[{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"cursor","type":{"kind":"SCALAR","name":"String","ofType":null}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"node","type":{"kind":"OBJECT","name":"Diagnostic","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---object-diagnostic-edge-fb32cf6adc9741a75d9e.js